<template>
  <div>
    <div class="accounts-section-wrapper content-wrapper">
      <progress-bar :currentStep="3"></progress-bar>

      <absa-pay-logo />

      <div class="header-request">
        <h3>{{ sidMessage.message }}</h3>
      </div>
      <form
        class="accounts-wrapper"
        id="absa-accounts-form"
        @submit.prevent="sendPaymentInstruction"
      >
        <div
          v-for="account in accounts"
          :key="account.accountIndex"
          class="account-item"
          :class="{ selected: selectedAccountIndex === account.accountIndex }"
          @click="selectAccount(account.accountIndex)"
        >
          <div class="acc-info-wrapper">
            <div class="acc-name">
              <div class="label">Account Name</div>
              <div class="value">{{ account.accountName }}</div>
            </div>

            <div class="acc-number">
              <div class="label">Account Number</div>
              <div class="value">{{ account.accountNumber }}</div>
            </div>
          </div>
        </div>

        <div class="notification">
          <p class="note">
            <span><img src="../assets/images/info.svg" alt="info" /></span>
            Please note
          </p>
          <p class="disclaimer">
            Absa will temporarily provide your account number to Payfast by
            Network for refund purposes only.
          </p>
        </div>

        <proceed-button
          :is-proceed-enable="!!selectedAccountIndex"
          :is-loading="isLoading"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ProgressBar from '@/components/ProgressBar'
import ProceedButton from '@/components/buttons/ProceedButton'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'
import axios from '@/wrapper'
import loadingManager from '@/LoadingManager'
import AbsaPayLogo from '../components/AbsaPayLogo.vue'
import SidMessage from '@/dto/SidMessage'
import { convertKeysToCamelCase } from '@/utils'

export default {
  name: 'Accounts',
  props: {
    instruction: {
      type: Object,
      default: () => {},
    },
    request: {
      type: Object,
      default: () => {},
    },
    sidMessage: {
      type: SidMessage,
      default: () => new SidMessage({}),
    },
  },
  components: {
    ProgressBar,
    ProceedButton,
    AbsaPayLogo,
  },
  mixins: [blockBackNavigationMixin],
  data() {
    return {
      selectedAccountIndex: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapGetters('merchantSettings', ['banksList']),
    transactionId() {
      return this.$route.query.transactionId
    },

    accounts() {
      const options = this.sidMessage?.options
      return convertKeysToCamelCase(options.Accounts) ?? []
    },

    bank() {
      return this.banksList.find(
        (item) => item.acquirerCode === this.transaction.acquirerCode
      )
    },
  },
  methods: {
    selectAccount(accountIndex) {
      this.selectedAccountIndex = accountIndex
    },
    async sendPaymentInstruction() {
      if (!this.selectedAccountIndex) {
        return
      }
      this.isLoading = true
      await axios
        .post('BankApi/AbsaPay/instruction', {
          transactionId: this.transactionId,
          accountIndex: this.selectedAccountIndex,
        })
        .then(() => {
          const message = 'Please wait while we finalise payment'
          this.sidMessage.message = message
          loadingManager.setMessage(message)
          loadingManager.setLoading(true)
        })
        .catch(function (err) {
          this.$handleException({ err, transactionId: this.transactionId })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.notification {
  margin: 20px auto;
  text-align: center;
  border-radius: 8px;
  background: #d2cdcd4d;
  padding: 1px 20px;

  .note {
    font-weight: 700;
  }

  .disclaimer {
    font-size: 12px;
  }
}
.accounts-wrapper {
  width: 360px;
  margin: 0 auto;
}

.acc-info-wrapper {
  display: flex;
  flex-direction: row;

  @media screen and (max-width: $mobile-resolution) {
    flex-direction: column;
  }
}

.account-item {
  padding: 10px 36px 10px 14px;
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  width: 100%;
  margin: 15px auto;
  border: 2px solid transparent;
  display: flex;
  align-items: center;

  &.selected {
    border: 2px solid #fcc700;
  }
}

.account-item:hover {
  cursor: pointer;
}

.acc-name,
.acc-number {
  margin-bottom: 0;

  @media screen and (max-width: $mobile-resolution) {
    margin-bottom: 10px;
  }
}

.acc-name + .acc-number {
  margin-left: 40px;

  @media screen and (max-width: $mobile-resolution) {
    margin-left: 0;
  }
}

.label {
  font-size: 10px;
  padding-bottom: 2px;
}

.value {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.5px;
}
</style>
